(() => {
 const bar=document.querySelector('[data-fasola-mobile-buybar]');
 const root=document.getElementById('fasola-native-root');
 const data=document.getElementById('fasola-native-data');
 if(!bar||!root||!data)return;
 const variants=JSON.parse(data.textContent).variants;
 const button=bar.querySelector('[data-fasola-mobile-add]');
 const form=document.getElementById(button.getAttribute('form'));
 if(!form)return;
 const price=bar.querySelector('[data-fasola-mobile-price]');
 function sync(){
  const id=form.querySelector('[name="id"]')?.value;
  const v=variants.find(x=>String(x.id)===String(id));
  if(!v)return;
  price.textContent=v.price;
  button.disabled=!v.available;
  button.textContent=v.available?button.dataset.addLabel:button.dataset.soldLabel;
 }
 form.addEventListener('change',sync);
 sync();

})();
